import React from "react";
import PropTypes from "prop-types";

import strings from "../../resources/strings";

class PrivacyPolicy extends React.Component {
    render() {
        let state = this.props.store.getState();

        if (
            state.questionSet &&
            state.questionSet.questionSet &&
            state.workflowSession &&
            state.questionSet.privacyPolicyUrl &&
            state.questionSet.privacyPolicyText &&
            (state.workflowSession.currentQuestionId === state.questionSet.questionSet.questions[0].questionID ||
                state.workflowSession.currentQuestionId === "")
        ) {
            return (
                <a className="w3-small w3-text-blue" href={state.questionSet.privacyPolicyUrl ? state.questionSet.privacyPolicyUrl : null}
                        target="_blank" rel="noopener noreferrer">
                    {state.questionSet.privacyPolicyText ? state.questionSet.privacyPolicyText : null}
                </a>
            );
        }

        return null;
    }
}

PrivacyPolicy.contextTypes = {
    store: PropTypes.object
};

export default PrivacyPolicy;
